import { Provider } from '@types';

export default function formatProviderNameWithTitle(
  provider: Provider,
): string {
  const { firstName, lastName, prefix, suffix } = provider;

  return `${prefix ? `${prefix} ` : ''}${firstName} ${lastName}${suffix ? `, ${suffix}` : ''}`;
}
